import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LatLngArray } from './map-types';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private latLngsSubject = new Subject<LatLngArray>();
  latLngs$: Observable<LatLngArray> = this.latLngsSubject.asObservable();

  updateLatLngsPolygon(latLngs: LatLngArray) {
    this.latLngsSubject.next(latLngs);
  }
}
